import script from "./CodeEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./CodeEditor.vue?vue&type=script&setup=true&lang=ts"

import "./CodeEditor.vue?vue&type=style&index=0&id=7b82a1c2&lang=scss"

const __exports__ = script;

export default __exports__